<div class="showroom-root">
  <iframe class="iframe-pdf" src="https://docs.google.com/viewer?url=https://cdn.littleworker.fr/assets/accompagnement.pdf&embedded=true"></iframe>
</div>
